import { createContext, useContext, useEffect, useState } from 'react';
import './header.scss';
import MenuMain from './dxMenuMain';
import logo from '../img/LogoSel32.png';
import { AccountContext } from '../context/account-context';
import { SettingsContext } from '../context/settings-context';
import { getAccount } from '../common/api-requests';
import { ErrorContext } from '../context/error-context';

export default function Header() {

    const [account, setAccount] = useContext(AccountContext);
    const [stateAccount, setStateAccount] = useState(account);
    
    const [settings, setSettings] = useContext(SettingsContext);
    const [accountInfo, setAccountInfo] = useState({});
    
    const [error, setError] = useContext(ErrorContext);
    const [stateError, setStateError] = useState(null);

    useEffect(()=>{
        setStateError(error);
    }, [error])

    useEffect(()=>{
        setStateAccount(account);
    }, [account])

    useEffect(() => {

        if (!stateAccount)
            return;

        getAccount(stateAccount.id).then((acc) => {

            if (acc){
                setAccountInfo(acc);
            }
        })
        .catch((errorInner) => {
            setError("(" + errorInner.status + ")" + " " + errorInner.text);
        });;

    }, [stateAccount]);

    if (!account)
        return <></>


    return (
        <header className="header">
            <div className="header-container-title">
                <img src={logo} className="logo" alt="logo" />
                <span className="header-title">СЦЕНАРІЇ</span>
            </div>

            <MenuMain></MenuMain>

            <span className='header-account' style={{ visibility: settings.isShowLoginName ? "visible" : "hidden" }} >{ accountInfo ? accountInfo.name + "(" + accountInfo.id + ")" : "" }  </span>
            <i style={{ display: stateError && stateError.isSocketError ? "block" : "none" }} className="dx-icon dx-icon-like" title="З'єднання з сокет-сервером перервано Ви не можете отримувати нові повідомлення."></i>
        
        </header>

    );
};